export default __webpack_public_path__ + "static/media/atatürkbayrak.3279a2b7.gif";